import { render, staticRenderFns } from "./ConsultaResolve.vue?vue&type=template&id=1d512f26&scoped=true"
import script from "./ConsultaResolve.vue?vue&type=script&lang=js"
export * from "./ConsultaResolve.vue?vue&type=script&lang=js"
import style0 from "./ConsultaResolve.vue?vue&type=style&index=0&id=1d512f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d512f26",
  null
  
)

export default component.exports